export const Phone = () => (
	<svg
		width="60"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="48" height="48" rx="24" fill="#F7941D" fillOpacity="0.1" />
		<mask
			id="mask0_306_574"
			style={{ maskType: "alpha" }}
			maskUnits="userSpaceOnUse"
			x="12"
			y="12"
			width="24"
			height="24"
		>
			<rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_306_574)">
			<path
				d="M31.0385 23.7308C30.9808 21.8128 30.2824 20.1843 28.9433 18.8452C27.6042 17.5061 25.9757 16.8077 24.0577 16.75V15.25C25.2244 15.2757 26.3167 15.5148 27.3346 15.9673C28.3526 16.4199 29.2417 17.0263 30.0019 17.7866C30.7622 18.5468 31.3686 19.4359 31.8211 20.4539C32.2737 21.4718 32.5128 22.5641 32.5384 23.7308H31.0385ZM27.0385 23.7308C26.9808 22.9295 26.6699 22.2452 26.1058 21.6779C25.5417 21.1106 24.859 20.8013 24.0577 20.75V19.25C25.2744 19.3013 26.3109 19.7568 27.1673 20.6164C28.0237 21.476 28.4807 22.5141 28.5384 23.7308H27.0385ZM31.4307 32.4423C29.4859 32.4423 27.5599 31.9807 25.6529 31.0577C23.7459 30.1346 22.0433 28.924 20.5452 27.4259C19.0472 25.9279 17.835 24.2269 16.9087 22.3231C15.9824 20.4192 15.5193 18.4949 15.5193 16.55C15.5193 16.25 15.6193 16 15.8193 15.8C16.0193 15.6 16.2693 15.5 16.5693 15.5H19.8308C20.0897 15.5 20.3157 15.5798 20.5087 15.7395C20.7016 15.8991 20.8211 16.1052 20.8673 16.3577L21.4404 19.3C21.4801 19.5462 21.476 19.7699 21.4279 19.9712C21.3798 20.1724 21.2744 20.3481 21.1115 20.4981L18.8115 22.7462C19.6013 24.0872 20.543 25.2987 21.6366 26.3808C22.7301 27.4628 23.968 28.4064 25.35 29.2116L27.5846 26.9385C27.7475 26.7757 27.9401 26.66 28.1625 26.5914C28.3849 26.5228 28.6128 26.5084 28.8462 26.5481L31.623 27.1135C31.8756 27.1699 32.0817 27.292 32.2413 27.4798C32.4009 27.6676 32.4807 27.891 32.4807 28.15V31.3923C32.4807 31.6923 32.3807 31.9423 32.1807 32.1423C31.9807 32.3423 31.7307 32.4423 31.4307 32.4423ZM18.0923 21.327L19.877 19.6193C19.909 19.5936 19.9298 19.5583 19.9395 19.5135C19.9491 19.4686 19.9475 19.4269 19.9346 19.3885L19.5 17.1539C19.4872 17.1026 19.4648 17.0641 19.4327 17.0385C19.4007 17.0128 19.359 17 19.3077 17H17.1693C17.1308 17 17.0987 17.0128 17.0731 17.0385C17.0475 17.0641 17.0346 17.0962 17.0346 17.1346C17.0859 17.818 17.1978 18.5122 17.3702 19.2173C17.5426 19.9225 17.7834 20.6257 18.0923 21.327ZM26.7538 29.9115C27.4167 30.2205 28.108 30.4567 28.8279 30.6202C29.5478 30.7837 30.2205 30.8808 30.8462 30.9115C30.8846 30.9115 30.9167 30.8987 30.9423 30.8731C30.968 30.8474 30.9808 30.8154 30.9808 30.7769V28.6731C30.9808 28.6218 30.968 28.5801 30.9423 28.5481C30.9167 28.516 30.8782 28.4936 30.8269 28.4808L28.7269 28.0538C28.6885 28.041 28.6548 28.0394 28.626 28.049C28.5971 28.0586 28.5667 28.0795 28.5346 28.1115L26.7538 29.9115Z"
				fill="#0E76BC"
			/>
		</g>
	</svg>
);
export const Star = () => (
	<svg
		width="17"
		height="16"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z"
			fill="#F5A623"
		/>
	</svg>
);
export const AdultIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_306_742"
			style={{ maskType: "luminance" }}
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="20"
			height="20"
		>
			<path d="M0 1.90735e-06H20V20H0V1.90735e-06Z" fill="white" />
		</mask>
		<g mask="url(#mask0_306_742)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.50837 10.6055C3.24777 10.6055 3.0365 10.3942 3.0365 10.1336V6.21996C3.0365 5.28733 3.79255 4.53125 4.72521 4.53125H6.23962C6.45536 4.53125 6.63025 4.35636 6.63025 4.14062C6.63025 3.92489 6.45536 3.75 6.23962 3.75H4.72521C3.36107 3.75 2.25525 4.85587 2.25525 6.21996V10.1336C2.25525 10.8257 2.81632 11.3867 3.50837 11.3867C4.20043 11.3867 4.7615 10.8257 4.7615 10.1336V8.31953C4.7615 8.1038 4.58661 7.92891 4.37087 7.92891C4.15514 7.92891 3.98025 8.1038 3.98025 8.31953V10.1336C3.98025 10.3942 3.76898 10.6055 3.50837 10.6055Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.71775 10.1336C7.71775 10.8257 8.27882 11.3867 8.97087 11.3867C9.66293 11.3867 10.224 10.8257 10.224 10.1336V6.21996C10.224 4.85587 9.11813 3.75 7.75404 3.75H6.23962C6.02389 3.75 5.849 3.92489 5.849 4.14062C5.849 4.35636 6.02389 4.53125 6.23962 4.53125H7.75404C8.68666 4.53125 9.44275 5.28734 9.44275 6.21996V10.1336C9.44275 10.3942 9.23148 10.6055 8.97087 10.6055C8.71027 10.6055 8.499 10.3942 8.499 10.1336V8.31953C8.499 8.1038 8.32411 7.92891 8.10837 7.92891C7.89264 7.92891 7.71775 8.1038 7.71775 8.31953V10.1336Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.23963 3.75C5.57204 3.75 5.03088 3.20883 5.03088 2.54129V1.98996C5.03088 1.32242 5.57204 0.78125 6.23963 0.78125C6.90718 0.78125 7.44834 1.32242 7.44834 1.98996V2.54129C7.44834 3.20883 6.90718 3.75 6.23963 3.75ZM4.24963 2.54129C4.24963 3.64031 5.14058 4.53125 6.23963 4.53125C7.33865 4.53125 8.22959 3.64031 8.22959 2.54129V1.98996C8.22959 0.890944 7.33865 0 6.23963 0C5.14058 0 4.24963 0.890938 4.24963 1.98996V2.54129Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98022 19.6094C3.98022 19.8251 4.15511 20 4.37085 20H6.2396C6.45534 20 6.63022 19.8251 6.63022 19.6094V11.9338C6.63022 11.7181 6.45534 11.5432 6.2396 11.5432C6.02386 11.5432 5.84897 11.7181 5.84897 11.9338V19.2188H4.76147V10.1114C4.76147 9.89567 4.58659 9.72078 4.37085 9.72078C4.15511 9.72078 3.98022 9.89567 3.98022 10.1114V19.6094Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.849 19.6094C5.849 19.8251 6.02389 20 6.23962 20H8.10837C8.32411 20 8.499 19.8251 8.499 19.6094V16.8625C8.499 16.6468 8.32411 16.4719 8.10837 16.4719C7.89264 16.4719 7.71775 16.6468 7.71775 16.8625V19.2188H6.23962C6.02389 19.2188 5.849 19.3936 5.849 19.6094Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.1084 13.7375C8.32413 13.7375 8.49902 13.5626 8.49902 13.3469V10.1114C8.49902 9.89562 8.32413 9.72073 8.1084 9.72073C7.89266 9.72073 7.71777 9.89562 7.71777 10.1114V13.3469C7.71777 13.5626 7.89266 13.7375 8.1084 13.7375Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98022 9.53125C3.98022 9.74699 4.15511 9.92188 4.37085 9.92188H8.10835C8.32409 9.92188 8.49897 9.74699 8.49897 9.53125V7.04305C8.49897 6.82731 8.32409 6.65242 8.10835 6.65242C7.89261 6.65242 7.71772 6.82731 7.71772 7.04305V9.14063H4.76147V7.04305C4.76147 6.82731 4.58659 6.65242 4.37085 6.65242C4.15511 6.65242 3.98022 6.82731 3.98022 7.04305V9.53125Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.6609 19.6094C11.6609 19.8251 11.8358 20 12.0515 20H13.614C13.8297 20 14.0046 19.8251 14.0046 19.6094V15C14.0046 14.7843 13.8297 14.6094 13.614 14.6094C13.3983 14.6094 13.2234 14.7843 13.2234 15V19.2188H12.4421V15C12.4421 14.7843 12.2672 14.6094 12.0515 14.6094C11.8358 14.6094 11.6609 14.7843 11.6609 15V19.6094Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.2234 19.6094C13.2234 19.8251 13.3983 20 13.614 20H15.1765C15.3922 20 15.5671 19.8251 15.5671 19.6094V15C15.5671 14.7843 15.3922 14.6094 15.1765 14.6094C14.9608 14.6094 14.7859 14.7843 14.7859 15V19.2188H14.0046V15C14.0046 14.7843 13.8297 14.6094 13.614 14.6094C13.3983 14.6094 13.2234 14.7843 13.2234 15V19.6094Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.614 3.75C13.0617 3.75 12.614 3.3023 12.614 2.75004V2.2707C12.614 1.7184 13.0617 1.2707 13.614 1.2707C14.1663 1.2707 14.614 1.7184 14.614 2.2707V2.75004C14.614 3.3023 14.1663 3.75 13.614 3.75ZM11.8328 2.75004C11.8328 3.7338 12.6303 4.53125 13.614 4.53125C14.5977 4.53125 15.3953 3.7338 15.3953 2.75004V2.2707C15.3953 1.28691 14.5977 0.489453 13.614 0.489453C12.6303 0.489453 11.8328 1.28691 11.8328 2.2707V2.75004Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3244 15.1131C10.3987 15.2005 10.5076 15.251 10.6223 15.251H16.5654C16.6801 15.251 16.789 15.2005 16.8632 15.113C16.9375 15.0256 16.9695 14.9099 16.9508 14.7967L16.1873 10.1772C16.1521 9.9644 15.9511 9.82036 15.7382 9.85554C15.5254 9.89072 15.3814 10.0918 15.4165 10.3046L16.1049 14.4697H11.0828L11.771 10.3046C11.8061 10.0918 11.6621 9.89071 11.4492 9.85554C11.2364 9.82037 11.0353 9.96441 11.0002 10.1773L10.2369 14.7967C10.2182 14.9099 10.2502 15.0256 10.3244 15.1131Z"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5415 10.4972C10.7572 10.5384 10.9644 10.3939 11.0002 10.1773L10.5415 10.4972ZM11.771 10.3047C11.6635 10.9546 11.0418 11.3882 10.3948 11.2646L10.3948 11.2646C9.77031 11.1452 9.3549 10.5496 9.45861 9.92234L9.45861 9.92233L10.0855 6.1314C10.0855 6.13139 10.0855 6.13139 10.0855 6.13139C10.3036 4.81284 11.5566 3.75 12.8931 3.75H13.6141C13.8298 3.75 14.0047 3.92489 14.0047 4.14063C14.0047 4.35636 13.8298 4.53125 13.6141 4.53125H12.8931C11.9389 4.53125 11.012 5.31748 10.8563 6.25884L10.8563 6.25885L10.2294 10.0498C10.2294 10.0498 10.2294 10.0498 10.2294 10.0498C10.1948 10.2589 10.3333 10.4574 10.5415 10.4972M11.771 10.3047C11.771 10.3047 11.771 10.3047 11.771 10.3047L12.213 7.63202C12.2482 7.41917 12.1042 7.21809 11.8913 7.18289C11.6785 7.1477 11.4774 7.29171 11.4422 7.50455L11.0002 10.1772L11.0002 10.1773"
				fill="#585C67"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4166 10.3047C15.524 10.9546 16.1458 11.3882 16.7927 11.2646L16.7928 11.2646C17.4173 11.1452 17.8327 10.5496 17.729 9.92234L17.729 9.92233L17.102 6.1314C17.102 6.13139 17.102 6.13139 17.102 6.13139C16.884 4.81284 15.6309 3.75 14.2945 3.75H13.5735C13.3578 3.75 13.1829 3.92489 13.1829 4.14063C13.1829 4.35636 13.3578 4.53125 13.5735 4.53125H14.2945C15.2487 4.53125 16.1756 5.31748 16.3313 6.25884L16.3313 6.25885L16.9582 10.0498C16.9582 10.0498 16.9582 10.0498 16.9582 10.0498C16.9927 10.2589 16.8542 10.4574 16.6461 10.4972M17.3429 9.98616L17.3436 9.98606L17.3429 9.98616C15.4166 10.3047 15.4166 10.3047 15.4166 10.3047ZM15.4166 10.3047L14.9746 7.63202C14.9394 7.41917 15.0834 7.21809 15.2962 7.18289C15.5091 7.1477 15.7102 7.29171 15.7454 7.50455L16.1874 10.1772L16.1874 10.1773C16.2232 10.3939 16.4304 10.5384 16.6461 10.4972"
				fill="#585C67"
			/>
		</g>
	</svg>
);
export const KidsIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_781)">
			<path
				d="M10 19.1667C7.10083 19.1667 4.46 17.7009 2.92917 15.2459C2.92 15.2342 2.91167 15.2225 2.905 15.2117C2.71583 14.9075 2.54083 14.5742 2.37 14.1959C1.9025 13.1234 1.66667 11.9942 1.66667 10.8334C1.65417 10.7809 1.25 8.07335 1.25 6.66669C1.25 2.64419 4.82583 2.15169 5.66083 2.09169C6.10667 1.69419 7.72 0.416687 10 0.416687C13.6333 0.416687 18.75 2.35585 18.75 6.66669C18.75 8.04752 18.3458 10.7792 18.3292 10.8942C18.3333 11.99 18.0983 13.1225 17.6333 14.1984C17.4475 14.6075 17.2442 14.9817 17.025 15.3192C17.0092 15.3434 16.9908 15.3667 16.97 15.3867C15.4867 17.73 12.8633 19.1667 10 19.1667ZM3.59667 14.7467C3.60583 14.7584 3.61417 14.7692 3.62083 14.7809C4.99667 17.005 7.38083 18.3334 10 18.3334C12.5767 18.3334 14.9375 17.0409 16.315 14.8767C16.3317 14.8517 16.35 14.8267 16.3717 14.8059C16.5217 14.5634 16.705 14.2259 16.8708 13.8609C17.2875 12.8975 17.5 11.8759 17.5 10.8334C17.5083 10.745 17.9167 7.98669 17.9167 6.66669C17.9167 2.93085 13.2875 1.25002 10 1.25002C7.69917 1.25002 6.14333 2.77919 6.12833 2.79502C6.05 2.87252 5.94417 2.91585 5.83417 2.91669C5.68083 2.91752 2.08333 2.97502 2.08333 6.66669C2.08333 8.01169 2.49167 10.7442 2.49583 10.7717C2.5 11.8784 2.7125 12.8967 3.1325 13.8584C3.28 14.1884 3.43333 14.4809 3.59667 14.7467Z"
				fill="#585C67"
			/>
			<path
				d="M17.74 12.9166C17.5592 12.9166 17.3925 12.7975 17.34 12.615L16.3525 9.16497C10.3242 9.11497 7.88255 7.61331 6.91088 6.56414C6.28171 8.18081 4.35588 8.88581 3.66921 9.08997L2.66088 12.6141C2.59755 12.8366 2.36588 12.965 2.14588 12.9C1.92505 12.8366 1.79671 12.6058 1.86005 12.385L2.93338 8.63497C2.97421 8.48997 3.09171 8.37831 3.23838 8.34414C3.26921 8.33664 6.27921 7.60164 6.27921 5.46581C6.27921 5.25497 6.43671 5.07747 6.64588 5.05247C6.85588 5.02164 7.05005 5.16164 7.10088 5.36664C7.10755 5.38914 8.04921 8.33331 16.6667 8.33331C16.8525 8.33331 17.0159 8.45581 17.0667 8.63497L18.14 12.385C18.2034 12.6066 18.075 12.8366 17.8542 12.9C17.8167 12.9116 17.7775 12.9166 17.74 12.9166Z"
				fill="#585C67"
			/>
			<path
				d="M17.9001 13.3334C17.8034 13.3334 17.7059 13.3242 17.6092 13.3159C17.3801 13.2934 17.2126 13.0892 17.2351 12.86C17.2576 12.6317 17.4584 12.4742 17.6901 12.4859C17.7601 12.4925 17.8301 12.5 17.9001 12.5C18.5892 12.5 19.1501 11.9392 19.1501 11.25C19.1501 10.615 18.6776 10.0809 18.0509 10.005C17.8226 9.97836 17.6592 9.77086 17.6867 9.5417C17.7142 9.3142 17.9234 9.14503 18.1501 9.17753C19.1951 9.30253 19.9834 10.1942 19.9834 11.2492C19.9834 12.3992 19.0484 13.3334 17.9001 13.3334Z"
				fill="#585C67"
			/>
			<path
				d="M2.08333 13.3334C0.935 13.3334 0 12.3992 0 11.25C0 10.185 0.7975 9.29336 1.85417 9.17753C2.08917 9.15753 2.28833 9.31753 2.31417 9.54586C2.34 9.7742 2.17417 9.98003 1.94583 10.0059C1.32167 10.0742 0.833333 10.6209 0.833333 11.25C0.833333 11.9392 1.39417 12.5 2.08333 12.5C2.15 12.5 2.2125 12.4942 2.26583 12.4834C2.49 12.4317 2.71167 12.5825 2.7575 12.8075C2.80417 13.0334 2.65833 13.2525 2.43333 13.2992C2.325 13.3217 2.20667 13.3334 2.08333 13.3334Z"
				fill="#585C67"
			/>
			<path
				d="M6.66663 12.5C5.97746 12.5 5.41663 11.9392 5.41663 11.25C5.41663 10.5608 5.97746 10 6.66663 10C7.35579 10 7.91663 10.5608 7.91663 11.25C7.91663 11.9392 7.35579 12.5 6.66663 12.5ZM6.66663 10.8333C6.43663 10.8333 6.24996 11.0208 6.24996 11.25C6.24996 11.4792 6.43663 11.6667 6.66663 11.6667C6.89663 11.6667 7.08329 11.4792 7.08329 11.25C7.08329 11.0208 6.89663 10.8333 6.66663 10.8333Z"
				fill="#585C67"
			/>
			<path
				d="M13.3334 12.5C12.6442 12.5 12.0834 11.9392 12.0834 11.25C12.0834 10.5608 12.6442 10 13.3334 10C14.0225 10 14.5834 10.5608 14.5834 11.25C14.5834 11.9392 14.0225 12.5 13.3334 12.5ZM13.3334 10.8333C13.1034 10.8333 12.9167 11.0208 12.9167 11.25C12.9167 11.4792 13.1034 11.6667 13.3334 11.6667C13.5634 11.6667 13.75 11.4792 13.75 11.25C13.75 11.0208 13.5634 10.8333 13.3334 10.8333Z"
				fill="#585C67"
			/>
			<path
				d="M10 15.8525C9.14667 15.8525 8.2925 15.5275 7.6425 14.8775C7.48 14.715 7.48 14.4508 7.6425 14.2883C7.805 14.1258 8.06917 14.1258 8.23167 14.2883C9.20667 15.2633 10.7925 15.2633 11.7675 14.2883C11.93 14.1258 12.1942 14.1258 12.3567 14.2883C12.5192 14.4508 12.5192 14.715 12.3567 14.8775C11.7075 15.5283 10.8533 15.8525 10 15.8525Z"
				fill="#585C67"
			/>
		</g>
		<defs>
			<clipPath id="clip0_306_781">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const PhoneTalk = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_306_979"
			style={{ maskType: "alpha" }}
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="24"
			height="24"
		>
			<rect width="24" height="24" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_306_979)">
			<path
				d="M19.0385 11.7307C18.9808 9.81277 18.2824 8.18425 16.9433 6.84515C15.6042 5.50605 13.9757 4.80765 12.0577 4.74995V3.25C13.2244 3.27563 14.3167 3.51473 15.3346 3.9673C16.3526 4.41987 17.2417 5.02627 18.0019 5.78653C18.7622 6.54678 19.3686 7.43587 19.8211 8.45382C20.2737 9.47176 20.5128 10.5641 20.5384 11.7307H19.0385ZM15.0385 11.7307C14.9808 10.9294 14.6699 10.2451 14.1058 9.67785C13.5417 9.11053 12.859 8.80123 12.0577 8.74995V7.25C13.2744 7.30128 14.3109 7.75672 15.1673 8.61632C16.0237 9.47594 16.4807 10.5141 16.5384 11.7307H15.0385ZM19.4307 20.4422C17.4859 20.4422 15.5599 19.9807 13.6529 19.0576C11.7459 18.1346 10.0433 16.924 8.54524 15.4259C7.04715 13.9278 5.83498 12.2269 4.90871 10.3231C3.98243 8.41922 3.51929 6.49487 3.51929 4.55C3.51929 4.25 3.61929 4 3.81929 3.8C4.01929 3.6 4.26929 3.5 4.56929 3.5H7.83076C8.08975 3.5 8.31571 3.57981 8.50866 3.73942C8.7016 3.89904 8.82115 4.10513 8.86731 4.3577L9.44039 7.29997C9.48012 7.54612 9.47595 7.76984 9.42789 7.97113C9.3798 8.17241 9.27435 8.34805 9.11154 8.49805L6.81154 10.7461C7.60129 12.0872 8.54296 13.2987 9.63656 14.3808C10.7301 15.4628 11.968 16.4064 13.35 17.2115L15.5846 14.9384C15.7475 14.7756 15.9401 14.6599 16.1625 14.5914C16.3849 14.5228 16.6128 14.5083 16.8462 14.5481L19.623 15.1135C19.8756 15.1699 20.0817 15.292 20.2413 15.4798C20.4009 15.6676 20.4807 15.891 20.4807 16.15V19.3922C20.4807 19.6922 20.3807 19.9422 20.1807 20.1422C19.9807 20.3422 19.7307 20.4422 19.4307 20.4422ZM6.09234 9.32692L7.87696 7.61922C7.90901 7.59357 7.92985 7.55832 7.93946 7.51345C7.94908 7.46857 7.94747 7.4269 7.93464 7.38845L7.50004 5.15382C7.4872 5.10254 7.46476 5.06408 7.43271 5.03845C7.40066 5.0128 7.359 4.99997 7.30771 4.99997H5.16926C5.1308 4.99997 5.09874 5.0128 5.07309 5.03845C5.04745 5.06408 5.03464 5.09613 5.03464 5.1346C5.0859 5.81793 5.19776 6.51217 5.37021 7.2173C5.54265 7.92243 5.78335 8.62564 6.09234 9.32692ZM14.7538 17.9115C15.4167 18.2205 16.108 18.4567 16.8279 18.6202C17.5478 18.7836 18.2205 18.8807 18.8462 18.9115C18.8846 18.9115 18.9167 18.8987 18.9423 18.873C18.968 18.8474 18.9808 18.8153 18.9808 18.7769V16.673C18.9808 16.6218 18.968 16.5801 18.9423 16.548C18.9167 16.516 18.8782 16.4935 18.8269 16.4807L16.7269 16.0538C16.6885 16.041 16.6548 16.0394 16.626 16.049C16.5971 16.0586 16.5667 16.0794 16.5346 16.1115L14.7538 17.9115Z"
				fill="white"
			/>
		</g>
	</svg>
);
export const Facebook = () => (
	<svg
		width="34"
		height="35"
		viewBox="0 0 34 35"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			y="0.757324"
			width="33.7222"
			height="33.7222"
			rx="16.8611"
			fill="#3B5998"
		/>
		<path
			d="M14.9756 24.9731V18.2689H13.152V15.8551H14.9756V13.7933C14.9756 12.1732 16.0529 10.6854 18.535 10.6854C19.54 10.6854 20.2832 10.7791 20.2832 10.7791L20.2246 13.0332C20.2246 13.0332 19.4667 13.026 18.6397 13.026C17.7446 13.026 17.6012 13.427 17.6012 14.0925V15.8551H20.2958L20.1785 18.2689H17.6012V24.9731H14.9756Z"
			fill="white"
		/>
	</svg>
);
export const WhatsApp = () => (
	<svg
		width="35"
		height="35"
		viewBox="0 0 35 35"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_884)">
			<path
				d="M-1.53441 18.0434C-1.53536 21.4476 -0.645873 24.7716 1.04546 27.7013L-1.69617 37.7115L8.54797 35.0254C11.3814 36.5679 14.556 37.3761 17.782 37.3763H17.7905C28.4403 37.3763 37.1094 28.7103 37.114 18.0587C37.116 12.8972 35.1078 8.04365 31.4591 4.39212C27.811 0.7409 22.9592 -1.27096 17.7897 -1.27332C7.13868 -1.27332 -1.52986 7.39224 -1.53426 18.0434"
				fill="url(#paint0_linear_306_884)"
			/>
			<path
				d="M-2.22442 18.0371C-2.22552 21.5638 -1.30416 25.0066 0.447483 28.0412L-2.39246 38.4102L8.219 35.6279C11.1428 37.2221 14.4347 38.0625 17.7844 38.0638H17.793C28.8249 38.0638 37.8055 29.086 37.8102 18.0531C37.8121 12.7061 35.7316 7.67814 31.9525 3.89579C28.173 0.11392 23.1477 -1.97034 17.793 -1.97253C6.7593 -1.97253 -2.22002 7.00396 -2.22442 18.0371ZM4.09493 27.5186L3.69871 26.8897C2.03313 24.2413 1.15401 21.1809 1.15527 18.0383C1.15888 8.86789 8.62212 1.407 17.7993 1.407C22.2436 1.40888 26.4203 3.14137 29.5617 6.28471C32.703 9.42837 34.4316 13.6072 34.4305 18.0518C34.4264 27.2223 26.963 34.6841 17.793 34.6841H17.7864C14.8006 34.6825 11.8723 33.8807 9.31845 32.3654L8.7107 32.005L2.41364 33.656L4.09493 27.5185V27.5186Z"
				fill="url(#paint1_linear_306_884)"
			/>
			<path
				d="M13.4097 10.7897C13.078 10.0388 12.7288 10.0237 12.4133 10.0105C12.1549 9.99916 11.8596 10 11.5645 10C11.2692 10 10.7893 10.1132 10.3837 10.5642C9.97763 11.0156 8.8335 12.1065 8.8335 14.3253C8.8335 16.5442 10.4205 18.6885 10.6417 18.9897C10.8633 19.2903 13.7055 23.9893 18.2069 25.797C21.948 27.2993 22.7094 27.0005 23.5213 26.9252C24.3334 26.8501 26.1416 25.8345 26.5105 24.7814C26.8797 23.7285 26.8797 22.8259 26.769 22.6373C26.6583 22.4494 26.363 22.3365 25.9201 22.1111C25.4771 21.8855 23.2998 20.7944 22.8939 20.6439C22.4878 20.4935 22.1926 20.4185 21.8973 20.8701C21.6019 21.3209 20.7539 22.3365 20.4954 22.6373C20.2371 22.9387 19.9786 22.9763 19.5359 22.7507C19.0927 22.5244 17.6664 22.0488 15.9743 20.5125C14.6577 19.3171 13.7689 17.8409 13.5106 17.3893C13.2522 16.9384 13.4829 16.694 13.705 16.4693C13.9039 16.2672 14.148 15.9427 14.3696 15.6794C14.5904 15.4161 14.6641 15.2282 14.8118 14.9274C14.9596 14.6263 14.8857 14.363 14.7751 14.1374C14.6641 13.9118 13.8035 11.6814 13.4097 10.7897Z"
				fill="white"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_306_884"
				x1="1938.81"
				y1="3897.2"
				x2="1938.81"
				y2="-1.27332"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#1FAF38" />
				<stop offset="1" stopColor="#60D669" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_306_884"
				x1="2007.74"
				y1="4036.3"
				x2="2007.74"
				y2="-1.97253"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F9F9F9" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
			<clipPath id="clip0_306_884">
				<rect
					width="34.1113"
					height="34.1113"
					fill="white"
					transform="translate(0.722168 0.757324)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const Plus = () => (
	<svg
		width="27"
		height="27"
		viewBox="0 0 27 27"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_913)">
			<path
				d="M19.4388 11.9215H14.7041V7.1868C14.7041 6.52991 14.1568 5.98254 13.4999 5.98254C12.8429 5.98254 12.2956 6.52986 12.2956 7.1868V11.9215H7.56095C6.90406 11.9215 6.35669 12.4688 6.35669 13.1258C6.35669 13.4541 6.49357 13.7552 6.71254 13.9741C6.93151 14.1931 7.23259 14.33 7.56091 14.33H12.2956V19.0647C12.2956 19.393 12.4325 19.6941 12.6514 19.913C12.8704 20.132 13.1715 20.2689 13.4998 20.2689C14.1567 20.2689 14.7041 19.7216 14.7041 19.0646V14.3299H19.4388C20.0956 14.3299 20.643 13.7826 20.643 13.1257C20.643 12.4687 20.123 11.9214 19.4388 11.9214L19.4388 11.9215Z"
				fill="currentColor"
			/>
			<path
				d="M13.5 0.125977C6.32947 0.125977 0.5 5.95545 0.5 13.126C0.5 20.2965 6.32947 26.126 13.5 26.126C20.6705 26.126 26.5 20.2965 26.5 13.126C26.5 5.95545 20.6705 0.125977 13.5 0.125977ZM13.5 23.7176C7.64316 23.7176 2.90842 18.9829 2.90842 13.126C2.90842 7.26909 7.64311 2.5344 13.5 2.5344C19.3569 2.5344 24.0916 7.26909 24.0916 13.126C24.0916 18.9829 19.3569 23.7176 13.5 23.7176Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_306_913">
				<rect
					width="26"
					height="26"
					fill="white"
					transform="translate(0.5 0.125977)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const Minus = () => (
	<svg
		width="27"
		height="27"
		viewBox="0 0 27 27"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_902)">
			<path
				d="M19.4386 11.9219C12.3029 11.9219 15.484 11.9219 7.5607 11.9219C6.90381 11.9219 6.35645 12.4692 6.35645 13.1261C6.35645 13.4545 6.49333 13.7556 6.71229 13.9745C6.93126 14.1935 7.23234 14.3304 7.56066 14.3304C14.4332 14.3304 11.8455 14.3303 19.4385 14.3303C20.0954 14.3303 20.6428 13.783 20.6428 13.1261C20.6428 12.4691 20.1228 11.9219 19.4386 11.9219Z"
				fill="currentColor"
			/>
			<path
				d="M13.5 0.125977C6.32947 0.125977 0.5 5.95545 0.5 13.126C0.5 20.2965 6.32947 26.126 13.5 26.126C20.6705 26.126 26.5 20.2965 26.5 13.126C26.5 5.95545 20.6705 0.125977 13.5 0.125977ZM13.5 23.7176C7.64316 23.7176 2.90842 18.9829 2.90842 13.126C2.90842 7.26909 7.64311 2.5344 13.5 2.5344C19.3569 2.5344 24.0916 7.26909 24.0916 13.126C24.0916 18.9829 19.3569 23.7176 13.5 23.7176Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_306_902">
				<rect
					width="26"
					height="26"
					fill="white"
					transform="translate(0.5 0.125977)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const FacebookIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_958)">
			<path
				d="M24.0001 12.0735C24.0001 5.40454 18.6271 -0.00146484 12.0001 -0.00146484C5.37007 3.51563e-05 -0.00292969 5.40454 -0.00292969 12.075C-0.00292969 18.1005 4.38607 23.0955 10.1221 24.0015V15.564H7.07707V12.075H10.1251V9.41253C10.1251 6.38704 11.9176 4.71603 14.6581 4.71603C15.9721 4.71603 17.3446 4.95154 17.3446 4.95154V7.92154H15.8311C14.3416 7.92154 13.8766 8.85303 13.8766 9.80853V12.0735H17.2036L16.6726 15.5625H13.8751V24C19.6111 23.094 24.0001 18.099 24.0001 12.0735Z"
				fill="#D2D3D6"
			/>
		</g>
		<defs>
			<clipPath id="clip0_306_958">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const InstagramIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_306_959)">
			<path
				d="M12 0C8.7435 0 8.334 0.015 7.0545 0.072C5.775 0.132 4.9035 0.333 4.14 0.63C3.33914 0.931229 2.61374 1.40374 2.0145 2.0145C1.40411 2.61404 0.931661 3.33936 0.63 4.14C0.333 4.902 0.1305 5.775 0.072 7.05C0.015 8.3325 0 8.7405 0 12.0015C0 15.2595 0.015 15.6675 0.072 16.947C0.132 18.225 0.333 19.0965 0.63 19.86C0.9375 20.649 1.347 21.318 2.0145 21.9855C2.6805 22.653 3.3495 23.064 4.1385 23.37C4.9035 23.667 5.7735 23.8695 7.0515 23.928C8.3325 23.985 8.7405 24 12 24C15.2595 24 15.666 23.985 16.947 23.928C18.2235 23.868 19.098 23.667 19.8615 23.37C20.6618 23.0686 21.3867 22.5961 21.9855 21.9855C22.653 21.318 23.0625 20.649 23.37 19.86C23.6655 19.0965 23.868 18.225 23.928 16.947C23.985 15.6675 24 15.2595 24 12C24 8.7405 23.985 8.3325 23.928 7.0515C23.868 5.775 23.6655 4.902 23.37 4.14C23.0684 3.33934 22.5959 2.61401 21.9855 2.0145C21.3864 1.40351 20.661 0.930968 19.86 0.63C19.095 0.333 18.222 0.1305 16.9455 0.072C15.6645 0.015 15.258 0 11.997 0H12.0015H12ZM10.9245 2.163H12.0015C15.2055 2.163 15.585 2.1735 16.8495 2.232C18.0195 2.2845 18.6555 2.481 19.0785 2.6445C19.638 2.862 20.0385 3.123 20.4585 3.543C20.8785 3.963 21.138 4.362 21.3555 4.923C21.5205 5.3445 21.7155 5.9805 21.768 7.1505C21.8265 8.415 21.8385 8.7945 21.8385 11.997C21.8385 15.1995 21.8265 15.5805 21.768 16.845C21.7155 18.015 21.519 18.6495 21.3555 19.0725C21.1631 19.5935 20.856 20.0647 20.457 20.451C20.037 20.871 19.638 21.1305 19.077 21.348C18.657 21.513 18.021 21.708 16.8495 21.762C15.585 21.819 15.2055 21.8325 12.0015 21.8325C8.7975 21.8325 8.4165 21.819 7.152 21.762C5.982 21.708 5.3475 21.513 4.9245 21.348C4.40325 21.1559 3.93169 20.8494 3.5445 20.451C3.14513 20.0641 2.83758 19.5925 2.6445 19.071C2.481 18.6495 2.2845 18.0135 2.232 16.8435C2.175 15.579 2.163 15.1995 2.163 11.994C2.163 8.79 2.175 8.412 2.232 7.1475C2.286 5.9775 2.481 5.3415 2.646 4.9185C2.8635 4.359 3.1245 3.9585 3.5445 3.5385C3.9645 3.1185 4.3635 2.859 4.9245 2.6415C5.3475 2.4765 5.982 2.2815 7.152 2.2275C8.259 2.1765 8.688 2.1615 10.9245 2.16V2.163ZM18.4065 4.155C18.2174 4.155 18.0301 4.19225 17.8554 4.26461C17.6807 4.33698 17.522 4.44305 17.3883 4.57677C17.2545 4.71048 17.1485 4.86923 17.0761 5.04394C17.0037 5.21864 16.9665 5.4059 16.9665 5.595C16.9665 5.7841 17.0037 5.97135 17.0761 6.14606C17.1485 6.32077 17.2545 6.47952 17.3883 6.61323C17.522 6.74695 17.6807 6.85302 17.8554 6.92539C18.0301 6.99775 18.2174 7.035 18.4065 7.035C18.7884 7.035 19.1547 6.88329 19.4247 6.61323C19.6948 6.34318 19.8465 5.97691 19.8465 5.595C19.8465 5.21309 19.6948 4.84682 19.4247 4.57677C19.1547 4.30671 18.7884 4.155 18.4065 4.155ZM12.0015 5.838C11.1841 5.82525 10.3723 5.97523 9.61347 6.27921C8.85459 6.58319 8.16377 7.03511 7.58123 7.60863C6.99868 8.18216 6.53605 8.86585 6.22026 9.61989C5.90448 10.3739 5.74185 11.1833 5.74185 12.0007C5.74185 12.8182 5.90448 13.6276 6.22026 14.3816C6.53605 15.1356 6.99868 15.8193 7.58123 16.3929C8.16377 16.9664 8.85459 17.4183 9.61347 17.7223C10.3723 18.0263 11.1841 18.1763 12.0015 18.1635C13.6193 18.1383 15.1623 17.4779 16.2975 16.3249C17.4326 15.1719 18.0689 13.6188 18.0689 12.0007C18.0689 10.3827 17.4326 8.82962 16.2975 7.67662C15.1623 6.52363 13.6193 5.86324 12.0015 5.838ZM12.0015 7.9995C13.0625 7.9995 14.08 8.42098 14.8303 9.17122C15.5805 9.92146 16.002 10.939 16.002 12C16.002 13.061 15.5805 14.0785 14.8303 14.8288C14.08 15.579 13.0625 16.0005 12.0015 16.0005C10.9405 16.0005 9.92296 15.579 9.17272 14.8288C8.42248 14.0785 8.001 13.061 8.001 12C8.001 10.939 8.42248 9.92146 9.17272 9.17122C9.92296 8.42098 10.9405 7.9995 12.0015 7.9995Z"
				fill="#D2D3D6"
			/>
		</g>
		<defs>
			<clipPath id="clip0_306_959">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
